 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import TITLE_PAGE from '@/components/Title_Page'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import LIST_OF_MAPS from '@/components/List_of_Maps'
 import AUTHORS_NOTE from '@/components/Authors_Note'
 import PREFACE from '@/components/Preface'
 import PART_I_EUROPE from '@/components/PART_I_EUROPE'
 import A_BECOMING_A_POW from '@/components/1_Becoming_a_POW'
 import A_SETTLING_IN_AND_GETTING_BY from '@/components/2_Settling_In_and_Getting_By'
 import A_USES_FOR_A_RED_CROSS_PARCEL_NUMBER_1__STRING from '@/components/3_Uses_for_a_Red_Cross_Parcel_Number_1__String'
 import A_FRIENDSHIPS_AND_FEUDS from '@/components/4_Friendships_and_Feuds'
 import A_SPORT from '@/components/5_Sport'
 import A_USES_FOR_A_RED_CROSS_PARCEL_NUMBER_2__CIGARETTES from '@/components/6_Uses_for_a_Red_Cross_Parcel_Number_2__Cigarettes'
 import A_STALAG_HAPPY__IMAGINARY_WORLDS_AND_OTHER_WAYS_OF_ESCAPE from '@/components/7_Stalag_Happy__Imaginary_Worlds_and_Other_Ways_of_Escape'
 import A_USES_FOR_A_RED_CROSS_PARCEL_NUMBER_3__TINS from '@/components/8_Uses_for_a_Red_Cross_Parcel_Number_3__Tins'
 import A_POW_ARTISTS from '@/components/9_POW_Artists'
 import PART_II_THE_WAR_IN_THE_EAST from '@/components/PART_II_THE_WAR_IN_THE_EAST'
 import A0_SURRENDER from '@/components/10_Surrender'
 import A1_CHANGI from '@/components/11_Changi'
 import A2_TURNED_OUT_RICE_AGAIN_FOOD_AND_COOKING from '@/components/12_Turned_Out_Rice_Again_Food_and_Cooking'
 import A3_MAKE_DO_AND_MEND from '@/components/13_Make_Do_and_Mend'
 import A4_ENTERTAINMENT_YOULL_NEVER_GET_OFF_THIS_ISLAND from '@/components/14_Entertainment_Youll_Never_Get_Off_this_Island'
 import A5_SPORT from '@/components/15_Sport'
 import A6_RECORDING_CAPTIVITY_THROUGH_ART_AND_PHOTOGRAPHY from '@/components/16_Recording_Captivity_Through_Art_and_Photography'
 import A7_POW_DOCTOR from '@/components/17_POW_Doctor'
 import A8_TAKING_FLIGHT_ESCAPE_THROUGH_BIRDWATCHING from '@/components/18_Taking_Flight_Escape_Through_Birdwatching'
 import A9_SURVIVAL_TEAMS from '@/components/19_Survival_Teams'
 import A0_ESCAPE_THROUGH_STUDY from '@/components/20_Escape_Through_Study'
 import A1_UNIVERSITY_OF_KUCHING from '@/components/21_University_of_Kuching'
 import A2_LANGUAGES_AND_COMMUNICATING_WITH_THE_OUTSIDE_WORLD from '@/components/22_Languages_and_Communicating_with_the_Outside_World'
 import A3_HIDDEN_WIRELESS_SETS from '@/components/23_Hidden_Wireless_Sets'
 import A4_RELIGION from '@/components/24_Religion'
 import A5_THE_MAGIC_OF_LETTERS_FROM_HOME from '@/components/25_The_Magic_of_Letters_from_Home'
 import A6_THE_CHANGI_MURALS from '@/components/26_The_Changi_Murals'
 import PART_III_EUROPE from '@/components/PART_III_EUROPE'
 import A7_READING_FOR_PROFIT from '@/components/27_Reading_for_Profit'
 import A8_GARDENING_AND_BIRDWATCHING from '@/components/28_Gardening_and_Birdwatching'
 import A9_STUDY from '@/components/29_Study'
 import A0_MUSIC_AND_THEATRE from '@/components/30_Music_and_Theatre'
 import PART_IV_THE_FAR_EAST from '@/components/PART_IV_THE_FAR_EAST'
 import A1_UPCOUNTRY_THE_THAILANDBURMA_RAILWAY from '@/components/31_Upcountry_The_ThailandBurma_Railway'
 import A2_ART_AND_MEDICINE_ON_THE_RAILWAY from '@/components/32_Art_and_Medicine_on_the_Railway'
 import A3_ARCHAEOLOGIST_ON_THE_DEATH_RAILWAY from '@/components/33_Archaeologist_on_the_Death_Railway'
 import A4_ENTERTAINMENT_AND_INGENUITY_IN_THAILAND from '@/components/34_Entertainment_and_Ingenuity_in_Thailand'
 import A5_HOME_AGAIN_CHANGI_GAOL from '@/components/35_Home_Again_Changi_Gaol'
 import A6_THE_POW_DIASPORA from '@/components/36_The_POW_Diaspora'
 import PART_V_FREEDOM from '@/components/PART_V_FREEDOM'
 import A7_SOMEWHERE_NEAR_THE_END from '@/components/37_Somewhere_Near_the_End'
 import A8_VICTORY_IN_THE_FAR_EAST from '@/components/38_Victory_in_the_Far_East'
 import A9_HOMECOMING from '@/components/39_Homecoming'
 import PART_VI_EXPOWS from '@/components/PART_VI_EX-POWS'
 import A0_AFTERMATH from '@/components/40_Aftermath'
 import ACKNOWLEDGEMENTS from '@/components/Acknowledgements'
 import NOTES from '@/components/Notes'
 import BIBLIOGRAPHY from '@/components/Bibliography'
 import INDEX from '@/components/Index'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Title_Page",
 			"name" : "Title_Page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/List_of_Maps",
 			"name" : "List_of_Maps",
 			"component" : LIST_OF_MAPS
 		},
 		{
 			"path" : "/Authors_Note",
 			"name" : "Authors_Note",
 			"component" : AUTHORS_NOTE
 		},
 		{
 			"path" : "/Preface",
 			"name" : "Preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/PART_I_EUROPE",
 			"name" : "PART_I_EUROPE",
 			"component" : PART_I_EUROPE
 		},
 		{
 			"path" : "/1_Becoming_a_POW",
 			"name" : "1_Becoming_a_POW",
 			"component" : A_BECOMING_A_POW
 		},
 		{
 			"path" : "/2_Settling_In_and_Getting_By",
 			"name" : "2_Settling_In_and_Getting_By",
 			"component" : A_SETTLING_IN_AND_GETTING_BY
 		},
 		{
 			"path" : "/3_Uses_for_a_Red_Cross_Parcel_Number_1__String",
 			"name" : "3_Uses_for_a_Red_Cross_Parcel_Number_1__String",
 			"component" : A_USES_FOR_A_RED_CROSS_PARCEL_NUMBER_1__STRING
 		},
 		{
 			"path" : "/4_Friendships_and_Feuds",
 			"name" : "4_Friendships_and_Feuds",
 			"component" : A_FRIENDSHIPS_AND_FEUDS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js